<template>
    <DsTag v-bind="getStatusTagProps(status)" />
</template>

<script setup lang="ts">
import type { DsTagProps } from '@/components/design-system/tag/DsTag.vue';
import DsTag from '@/components/design-system/tag/DsTag.vue';
import type { PayoffOrder } from '@/interfaces/payoff/payoff-order.types';
import { PayoffOrderStatus } from '@/interfaces/payoff/payoff-order.types';

defineProps<{
    status: PayoffOrderStatus;
}>();

const statusBadgeMap: Record<PayoffOrder['status'], DsTagProps> = {
    [PayoffOrderStatus.COMPLETED]: { text: 'Completed', variant: 'success' },
    [PayoffOrderStatus.UNRETRIEVABLE]: { text: 'Unretrievable', variant: 'error' },
    [PayoffOrderStatus.REQUESTED]: { text: 'Requested', variant: 'inactive' },
    [PayoffOrderStatus.NEEDS_REVIEW]: { text: 'Needs review', variant: 'warning' },
};

const getStatusTagProps = (status: PayoffOrder['status']): DsTagProps => {
    return statusBadgeMap[status] || { text: 'Unknown', variant: 'inactive' };
};
</script>
